import { render, staticRenderFns } from "./dbFuncList.vue?vue&type=template&id=a6fd0ee4&scoped=true&"
import script from "./dbFuncList.vue?vue&type=script&lang=js&"
export * from "./dbFuncList.vue?vue&type=script&lang=js&"
import style0 from "./dbFuncList.vue?vue&type=style&index=0&id=a6fd0ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fd0ee4",
  null
  
)

export default component.exports